module.exports = __webpack_public_path__ + "img/academic.16edce96.svg";